import { supabase } from "@/integrations/supabase/client";

export type ServiceRow = {
  id: string; slug: string; name: string; price: number; category: string;
  description: string | null; note: string | null; active: boolean; sort_order: number;
  price_type?: "fixed" | "variable";
};
export type PackageRow = {
  id: string; slug: string; name: string; price: number; original_value: number;
  savings: number; description: string | null; sort_order: number;
  service_ids: string[]; bonus_service_ids: string[];
};
export type FaqRow = { id: string; question: string; answer: string; sort_order: number };
export type SettingsMap = Record<string, any>;

export async function fetchServices(): Promise<ServiceRow[]> {
  const { data, error } = await (supabase as any)
    .from("services").select("*").eq("active", true).order("sort_order");
  if (error) throw error;
  return (data ?? []) as ServiceRow[];
}

export async function fetchPackages(): Promise<PackageRow[]> {
  const { data, error } = await (supabase as any).rpc("get_packages_with_services");
  if (error) throw error;
  return (data ?? []) as PackageRow[];
}

export async function fetchFaq(): Promise<FaqRow[]> {
  const { data, error } = await supabase
    .from("faq_items").select("id,question,answer,sort_order").eq("active", true).order("sort_order");
  if (error) throw error;
  return (data ?? []) as FaqRow[];
}

export async function fetchSettings(): Promise<SettingsMap> {
  const { data, error } = await supabase.from("site_settings").select("key,value");
  if (error) throw error;
  const map: SettingsMap = {};
  for (const r of data ?? []) map[r.key] = r.value;
  return map;
}
